import pick from 'lodash/pick'
import { action, makeObservable, observable } from 'mobx'

const LOCATION_HISTORY_SIZE = 30
const DEFAULT_LOCATION = {
  pathname: '',
  search: '',
  hash: '',
  state: undefined,
}

class RouterStore {
  @observable.ref location = DEFAULT_LOCATION
  history = null

  constructor () {
    makeObservable(this)
    this.push = this.push.bind(this)
    this.replace = this.replace.bind(this)
    this.go = this.go.bind(this)
    this.goBack = this.goBack.bind(this)
    this.goForward = this.goForward.bind(this)
  }

  _getHistory () {
    if (!this.history) {
      throw new Error('RouterStore history is not initialized')
    }
    return this.history
  }

  push (location, state) {
    this._getHistory().push(location, state)
  }

  replace (location, state) {
    this._getHistory().replace(location, state)
  }

  go (n) {
    this._getHistory().go(n)
  }

  goBack () {
    this._getHistory().goBack()
  }

  goForward () {
    this._getHistory().goForward()
  }

  /** Stores last LOCATION_HISTORY_SIZE location entries */
  @observable.shallow locationHistory = []

  @action
  _updateLocation (newState) {
    this.location = newState
    this.locationHistory = [
      ...this.locationHistory.slice(-LOCATION_HISTORY_SIZE + 1),
      pick(newState, ['pathname', 'search', 'hash']),
    ]
  }

  /**
   * Find the first entry in history with a matching pathname and push it
   *
   * If the entry is not found, use fallback if provided.
   * Use this method to go back to specific views without losing the params
   * chosen by the user.
   * */
  @action.bound
  pushFromHistory (pathnamePattern, fallback) {
    const matchingEntry = this.locationHistory.reverse().find(loc => loc.pathname.match(pathnamePattern))
    if (matchingEntry || fallback) {
      this.push(matchingEntry || fallback)
    }
  }

  getSearchParamValue (paramName, defaultValue = undefined) {
    const params = new URLSearchParams(this.location.search)
    return params.get(paramName) || defaultValue
  }

  @action.bound
  openInBlank (url) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

export default RouterStore
